import { Practitioner } from "./practitioner";
import { SearchPractitionerRequest } from "./search-practitioner.request";

export class SearchPractitionerResult {
  private request: SearchPractitionerRequest;
  private start: number;
  private total: number;
  private totalPerPages: number;
  private practitioners: Practitioner[];

  constructor() {
    this.practitioners = [];
  }

  public getRequest(): SearchPractitionerRequest {
    return this.request;
  }

  public setRequest(value: SearchPractitionerRequest): void {
    this.request = value;
  }

  public getStart(): number {
    return this.start;
  }

  public setStart(value: number): void {
    this.start = value;
  }

  public getTotal(): number {
    return this.total;
  }

  public setTotal(value: number): void {
    this.total = value;
  }

  public getTotalPerPages(): number {
    return this.totalPerPages;
  }

  public setTotalPerPages(value: number): void {
    this.totalPerPages = value;
  }

  public getPractitioners(): Practitioner[] {
    return this.practitioners;
  }

  public setPractitioners(value: Practitioner[]): void {
    this.practitioners = value;
  }

  public concatPractitioners(value: Practitioner[]): void {
    this.practitioners = this.practitioners.concat(value);
  }

  public addPractitioner(value: Practitioner): void {
    this.practitioners.push(value);
  }
}
